// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import MarketigToolTable from './marketing-table';
// assets
//

// ----------------------------------------------------------------------

export default function MarketingTools() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <MarketigToolTable />
        </Container >
    );
}
